@if (this.sidenavItems | async; as sidenavItems) {
    <div>
        <div class="flex-items-center h-14 pt-2">
            <mat-nav-list class="expansion-icon-nav-list">
                <mat-list-item (click)="this.toggleExpanded()">
                    <mat-icon
                        mat-list-icon
                        class="relative bottom-[-3px] select-none"
                        color="primary"
                        [matTooltip]="this.isExpanded ? 'Menü einklappen' : 'Menü ausklappen'"
                        matTooltipPosition="after"
                        [fontSet]="'material-symbols-rounded'"
                    >
                        {{ this.isExpanded ? 'arrow_back_ios_new' : 'arrow_forward_ios' }}
                    </mat-icon>
                </mat-list-item>
            </mat-nav-list>
        </div>

        <app-nav-list-separator [separator]="{ type: 'separator', key: 'expansion-icon-separator' }"></app-nav-list-separator>

        <mat-nav-list>
            @for (navItem of sidenavItems.top; track navItem.key) {
                @if (navItem.type === 'separator') {
                    <app-nav-list-separator [separator]="navItem"></app-nav-list-separator>
                } @else {
                    <app-nav-item
                        [navItem]="navItem"
                        [isExpanded]="this.isExpanded"
                        (closeMenu)="this.isExpanded ? toggleExpanded() : ''"
                    ></app-nav-item>
                }
            }
        </mat-nav-list>
    </div>

    <div>
        <mat-nav-list>
            @for (navItem of sidenavItems.bottom; track navItem.key) {
                @if (navItem.type === 'separator') {
                    <app-nav-list-separator [separator]="navItem"></app-nav-list-separator>
                } @else {
                    <app-nav-item
                        [navItem]="navItem"
                        [isExpanded]="this.isExpanded"
                        (closeMenu)="this.isExpanded ? toggleExpanded() : ''"
                    ></app-nav-item>
                }
            }
        </mat-nav-list>
    </div>
}
